import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { DefaultCarrierByCountryServiceEntryFragmentFragmentDoc } from '../fragments/defaultCarrierByCountryServiceEntry.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDefaultCarrierByCountryConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDefaultCarrierByCountryConfigQuery = { __typename?: 'Query', getDefaultCarrierByCountryConfig: Array<{ __typename?: 'DefaultCarrierByCountryEntry', country_code: string, defaults: Array<{ __typename?: 'DefaultCarrierByCountryServiceEntry', carrier_service: Types.OpsOrderCarrierService, carrier: Types.OpsOrderCarrier }> }> };


export const GetDefaultCarrierByCountryConfigDocument = gql`
    query GetDefaultCarrierByCountryConfig {
  getDefaultCarrierByCountryConfig {
    country_code
    defaults {
      ...DefaultCarrierByCountryServiceEntryFragment
    }
  }
}
    ${DefaultCarrierByCountryServiceEntryFragmentFragmentDoc}`;

/**
 * __useGetDefaultCarrierByCountryConfigQuery__
 *
 * To run a query within a React component, call `useGetDefaultCarrierByCountryConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultCarrierByCountryConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultCarrierByCountryConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultCarrierByCountryConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultCarrierByCountryConfigQuery, GetDefaultCarrierByCountryConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultCarrierByCountryConfigQuery, GetDefaultCarrierByCountryConfigQueryVariables>(GetDefaultCarrierByCountryConfigDocument, options);
      }
export function useGetDefaultCarrierByCountryConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultCarrierByCountryConfigQuery, GetDefaultCarrierByCountryConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultCarrierByCountryConfigQuery, GetDefaultCarrierByCountryConfigQueryVariables>(GetDefaultCarrierByCountryConfigDocument, options);
        }
export type GetDefaultCarrierByCountryConfigQueryHookResult = ReturnType<typeof useGetDefaultCarrierByCountryConfigQuery>;
export type GetDefaultCarrierByCountryConfigLazyQueryHookResult = ReturnType<typeof useGetDefaultCarrierByCountryConfigLazyQuery>;
export type GetDefaultCarrierByCountryConfigQueryResult = Apollo.QueryResult<GetDefaultCarrierByCountryConfigQuery, GetDefaultCarrierByCountryConfigQueryVariables>;